import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import CircleType from 'circletype';

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";
import { faChessKnight } from "@fortawesome/free-solid-svg-icons";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { faSquareArrowUpRight } from "@fortawesome/free-solid-svg-icons";

import "../App.css";

import heroBanner from "../assets/shapes/hero-banner-shape-bg.png";
import logo from "../logo.svg";
import bgImage from "../assets/SS.png";
import teamVideo from "../assets/Team.mp4";
import asia from "../assets/asia petroleum logo.png";
import faisal from "../assets/faisal-industries-logo.png";
import brb from "../assets/brb-engineering-logo.webp";
import istlogo from "../assets/IST logo.png";
import primerx from "../assets/PrimeRx.png";

import aboutImage from "../assets/amna.jpg";
import whyChooseImg from "../assets/team-work.jpg";
import starImage from "../assets/shapes/star.png";

const accordionData = [
  {
    title: " Experienced and Skilled Team",
    content:
      "We prioritize our clients' needs and goals, working closely with you to understand your business challenges and tailor our solutions accordingly. Our client-centric approach ensures.",
    id: 1,
  },
  {
    title: " Client-Centric Approach",
    content:
      "We take a client-first approach, ensuring that our solutions meet your specific business needs with a focus on collaboration and success.",
    id: 2,
  },
  {
    title: " Comprehensive Service Portfolio",
    content:
      "We provide a wide range of IT and business solutions, covering everything from development to digital marketing.",
    id: 3,
  },
  {
    title: " Robust Security Measures",
    content:
      "Our solutions are built with security in mind, implementing best practices to safeguard your data and business.",
    id: 4,
  },
];

function Home() {
  const brandImages = [istlogo, primerx, asia, faisal, brb, istlogo, primerx, asia, faisal, brb];

  const services = [
    {
      title: "AI Agents & Voice Automation",
      description:
        "Enterprise AI agents that automate workflows and handle natural voice conversations, 24/7.",
      fontawesome: "fa-solid fa-robot",
      link: "/solutions#ai-agents",
      delay: "100",
    },
    {
      title: "AI Video & Image Intelligence",
      description:
        "Real-time surveillance and SOP-compliance monitoring, powered by video and image AI.",
      fontawesome: "fa-solid fa-video",
      link: "/solutions#ai-surveillance",
      delay: "200",
    },
    {
      title: "Enterprise ERP & Business Systems",
      description:
        "Unify finance, inventory, sales and HR into one real-time source of truth.",
      fontawesome: "fa-solid fa-chart-line",
      link: "/solutions#erp",
      delay: "300",
    },
    {
      title: "Managed IT & Cloud",
      description:
        "24/7 monitoring, cloud migration and infrastructure that just works.",
      fontawesome: "fa-solid fa-cloud",
      link: "/solutions#managed-it-cloud",
      delay: "400",
    },
  ];

  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const slideTextData = [
    "AI Agents",
    "Voice Automation",
    "AI Video Intelligence",
    "SOP Monitoring",
    "Enterprise ERP",
    "Managed IT Services",
    "Cloud Infrastructure",
    "VoIP & Unified Comms",
    "Systems Integration",
    "Remote Support & BPO",
    "Web & App Development",
  ];

  // const funFacts = [
  //   {
  //     id: 1,
  //     count: 85,
  //     suffix: "%",
  //     text: "Success Project",
  //     duration: 2200,
  //     delay: 10,
  //   },
  //   {
  //     id: 2,
  //     count: 22,
  //     suffix: "+",
  //     text: "Years OF Experience",
  //     duration: 2300,
  //     delay: 10,
  //   },
  //   {
  //     id: 3,
  //     count: 12,
  //     suffix: "+",
  //     text: "Awards",
  //     duration: 2400,
  //     delay: 10,
  //   },
  //   {
  //     id: 4,
  //     count: 55,
  //     suffix: "K",
  //     text: "Satisfied Clients",
  //     duration: 2500,
  //     delay: 10,
  //   },
  // ];

  const text = " Epaging Private Limited";
  const letterSpacing = -360 / text.length;

  const textRef = useRef(null);

  useEffect(() => {
    const circleType = new CircleType(textRef.current);
    circleType.radius(62);
  }, []);

  return (
    <div className="page-wrapper">
      <div id="smooth-wrapper">
        <div id="smooth-content">
          {/* <main> */}
          <section className="hero-banner-one">

            <div
              className="hero-banner-one__shape"
              style={{ backgroundImage: `url(${heroBanner})` }}
              data-aos="zoom-out-down"
              data-aos-duration="1200"
              data-aos-delay="100"
            ></div>
            <div className="container"
              data-aos="zoom-out-down"
              data-aos-duration="1200"
              data-aos-delay="100">
              <div className="row d-flex align-items-center">
                <div className="col-md-9">
                  <div className="hero-banner-one__content">
                    <h3 className="hero-banner-one__title">
                      AI-powered technology for{" "}
                      <span>Enterprise Operations</span>
                    </h3>
                    <p className="hero-banner-one__text">
                      AI agents, video intelligence, and cloud infrastructure
                      — engineered end-to-end by one partner, so your
                      operations never miss a beat.
                    </p>
                    <a href="/contact" className="lotech-btn">
                      <span>Contact Us</span>
                      <span className="lotech-btn__icon">
                        <FontAwesomeIcon icon={faArrowRight} />
                      </span>
                    </a>
                  </div>
                </div>

                <div className="col-md-3 tp-btn-trigger">
                  <div className="hero-banner-one__circle tp-btn-bounce">
                    <div className="hero-banner-one__circle__logo">
                      <img src={logo} alt="epaging" />
                    </div>
                    <div className="curved-circle">
                      <div
                        className="curved-circle--item"
                        ref={textRef}
                        data-circle-text-options='{ "radius": 62, "forceWidth": true, "forceHeight": true }'
                      >
                        Epaging Private Limited
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="video-one">
            <div className="container">
              <div className="video-one__wrapper relative flex justify-center items-center">
                <video
                  className="video-one__media"
                  src={teamVideo}
                  poster={bgImage}
                  autoPlay
                  muted
                  loop
                  playsInline
                  preload="metadata"
                />
                <span className="video-one__caption">
                  <span className="dot"></span>
                  The Epaging Team
                </span>
              </div>
            </div>
          </section>

          <div className="client-carousel-1">
            <div
              className="container"
              data-aos="zoom-out-down"
              data-aos-duration="1200"
              data-aos-delay="100"
            >
              <p className="client-carousel__title">2K Brands Trust Us</p>
              <Swiper
                modules={[Autoplay, Pagination]}
                navigation={false}
                pagination={{ clickable: false }}
                spaceBetween={65}
                slidesPerView={5}
                loop={true}
                autoplay={{ delay: 6000, disableOnInteraction: false }}
                breakpoints={{
                  0: { slidesPerView: 1, spaceBetween: 0 },
                  360: { slidesPerView: 2, spaceBetween: 30 },
                  575: { slidesPerView: 3, spaceBetween: 30 },
                  768: { slidesPerView: 4, spaceBetween: 40 },
                  992: { slidesPerView: 4, spaceBetween: 40 },
                  1200: { slidesPerView: 5, spaceBetween: 80 },
                }}
                className="client-carousel__one"
              >
                {brandImages.map((src, index) => (
                  <SwiperSlide
                    key={index}
                    className="client-carousel__one__item"
                  >
                    <img src={src} alt={`Brand ${index + 1}`} />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>

          <section className="about-one">
            <div className="container">
              <div className="row">
                <div className="col-xl-6 d-flex align-items-center">
                  {/* Content Section */}
                  <div className="about-one__content">
                    <div className="sec-title text-left">
                      <h6 className="sec-title__tagline bw-split-text">
                        Our About Us
                      </h6>
                      <h3 className="sec-title__title bw-split-text">
                        Here’s what you should expect:
                      </h3>
                    </div>

                    <div className="about-one__box">
                      <div className="about-one__box__icon">
                        <FontAwesomeIcon icon={faCheck} />
                      </div>
                      <div>
                        <h5 className="about-one__box__title">
                          AI Built Into Every Solution
                        </h5>
                        <p className="about-one__box__text">
                          From voice agents to video intelligence, AI isn't an
                          add-on — it's how we build.
                        </p>
                      </div>
                    </div>

                    <div className="about-one__box">
                      <div className="about-one__box__icon">
                        <FontAwesomeIcon icon={faCheck} />
                      </div>
                      <div>
                        <h5 className="about-one__box__title">
                          24/7 Support, On-Site & Remote
                        </h5>
                        <p className="about-one__box__text">
                          Our highly skilled staff eliminates IT-related
                          threats before they become problems, day or night.
                        </p>
                      </div>
                    </div>

                    <div className="about-one__box">
                      <div className="about-one__box__icon">
                        <FontAwesomeIcon icon={faCheck} />
                      </div>
                      <div>
                        <h5 className="about-one__box__title">
                          One Partner, Every System
                        </h5>
                        <p className="about-one__box__text">
                          AI, ERP, cloud, communications and support teams —
                          all under one roof.
                        </p>
                      </div>
                    </div>

                    <div className="about-one__content__btn">
                      <a href="contact" className="lotech-btn">
                        <span>
                          Contact Us
                          <span className="lotech-btn__icon">
                            <FontAwesomeIcon icon={faArrowRight} />
                          </span>
                        </span>
                      </a>

                    </div>
                  </div>
                </div>
                {/* Image Section */}
                <div className="col-xl-6 text-end">
                  <div
                    className="about-one__image"
                    data-speed="1.1"
                    data-lag="0"
                  >
                    <img src={aboutImage} alt="epaging" />
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section
            className="slide-text"
            data-aos="fade-up"
            data-aos-duration="1200"
            data-aos-delay="200"
          >
            <div className="slide-text__one">
              <ul className="slide-text__one__list list-unstyled">
                {slideTextData.map((item, index) => (
                  <li key={index}>
                    {index % 2 === 0 ? (
                      <img src={starImage} alt="star" />
                    ) : (
                      <span className="slide-text__one__ball"></span>
                    )}
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            <div className="slide-text__two">
              <ul className="slide-text__two__list list-unstyled">
                {slideTextData.map((item, index) => (
                  <li key={index}>
                    {index % 2 === 0 ? (
                      <img src={starImage} alt="star" />
                    ) : (
                      <span className="slide-text__two__ball"></span>
                    )}
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </section>

          <section className="service-one">
            <div className="container">
              <div className="sec-title text-center">
                <h6 className="sec-title__tagline bw-split-text">
                  Where We Start
                </h6>
                <h3 className="sec-title__title bw-split-text">
                  AI-First Enterprise Solutions
                </h3>
              </div>
              <div className="row gutter-y-30 gutter-x-24">
                {services.map((service, index) => (
                  <div
                    key={index}
                    className="col-xl-3 col-md-6"
                    data-aos="fade-up"
                    data-aos-duration={1200 + index * 100}
                    data-aos-delay={service.delay}
                  >
                    <div className="service-one__item">
                      <div className="service-one__item__hover">
                        <div className="service-one__item__hover__left"></div>
                        <div className="service-one__item__hover__right"></div>
                      </div>
                      <div className="service-one__item__icon">
                        <i className={service.fontawesome}></i>
                      </div>
                      <h3 className="service-one__item__title">
                        <Link to={service.link}>{service.title}</Link>
                      </h3>
                      <p className="service-one__item__text">
                        {service.description}
                      </p>
                      <Link
                        to={service.link}
                        className="service-one__item__btn"
                      >
                        <span className="service-one__item__btn__text">
                          Read More
                        </span>
                        <span className="service-one__item__btn__icon">
                          <FontAwesomeIcon icon={faSquareArrowUpRight} />
                        </span>
                      </Link>
                    </div>
                  </div>
                ))}
              </div>
              <div
                className="service-one__text"
                data-aos="fade-up"
                data-aos-duration="1600"
                data-aos-delay="500"
              >
                Enterprise technology built specifically for your business:{" "}
                <Link to="/solutions">Explore all solutions</Link>
              </div>
            </div>
          </section>



          <section className="why-choose-one">
            <div className="container">
              <div className="row d-flex align-items-end">
                <div className="col-lg-6">
                  <div className="sec-title text-left">
                    <h6 className="sec-title__tagline bw-split-text">
                      Why Choose Us
                    </h6>
                    {/* <h3 className="sec-title__title bw-split-text">
                      Design The Concept Of <br /> Your Business
                    </h3> */}
                  </div>
                  <div
                    className="why-choose-one__image"
                    data-speed="1.1"
                    data-lag="0"
                  >
                    <img src={whyChooseImg} alt="epaging" />
                  </div>
                </div>
                <div
                  className="col-lg-6"
                  data-aos="flip-down"
                  data-aos-duration="1400"
                  data-aos-delay="200"
                >
                  <div className="why-choose-one__accordion lotech-accrodion">
                    {accordionData.map((item, index) => (
                      <div
                        className={`accrodion ${activeIndex === index ? "active" : ""
                          }`}
                        key={item.id}
                      >
                        <div
                          className="accrodion-title"
                          onClick={() => toggleAccordion(index)}
                        >
                          <h4>
                            <span className="accrodion-title__number">:</span>
                            {item.title}
                            <span
                              className={`accrodion-title__icon ${activeIndex === index ? "open" : ""
                                }`}
                            ></span>
                          </h4>
                        </div>
                        <div
                          className="accrodion-content"
                          style={{
                            display: activeIndex === index ? "block" : "none",
                          }}
                        >
                          <div className="inner">
                            <p>{item.content}</p>
                            {/* <a href="/about" className="inner__btn">
                              <span className="inner__btn__text">
                                Read More
                              </span>
                              <span className="inner__btn__icon">
                                <FontAwesomeIcon icon={faSquareArrowUpRight} />
                              </span>
                            </a> */}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* <section className="funfact-one">
              <div className="container">
                <div className="row gutter-y-30 gutter-x-24">
                  {funFacts.map(
                    ({ id, count, suffix, text, duration, delay }) => (
                      <div
                        key={id}
                        className="col-lg-3 col-md-6"
                        data-aos="zoom-in-up"
                        data-aos-duration={duration}
                        data-aos-delay={delay}
                      >
                        <div className="funfact-one__item count-box">
                          <h3 className="funfact-one__item__count">
                            <CountUp end={count} duration={20} />
                            {suffix}
                          </h3>
                          <div className="funfact-one__item__divider"></div>
                          <p className="funfact-one__item__text">{text}</p>
                        </div>
                      </div>
                    )
                  )}
                </div>
              </div>
            </section> */}
          {/* </main> */}
        </div>
      </div>
    </div>
  );
}

export default Home;
